export var applyTrackBy = function (trackBy, item) {
    if (typeof trackBy === 'function') {
        return trackBy(item);
    }
    return item[trackBy];
};
export var getItemKey = function (trackBy, item, index) {
    if (!trackBy) {
        return index;
    }
    return applyTrackBy(trackBy, item);
};
export var getTrackableValue = function (trackBy, item) {
    if (!trackBy) {
        return item;
    }
    return applyTrackBy(trackBy, item);
};
export var findWithTrackBy = function (trackBy, items, toFind) {
    var trackedToFind = getTrackableValue(trackBy, toFind);
    return items.filter(function (item) { return getTrackableValue(trackBy, item) === trackedToFind; })[0];
};
export var getColumnKey = function (column, index) {
    return column.id || index;
};
var stateToIcon = {
    sortable: 'caret-down',
    ascending: 'caret-down-filled',
    descending: 'caret-up-filled'
};
var stateToAriaSort = {
    sortable: 'none',
    ascending: 'ascending',
    descending: 'descending'
};
export var getSortingStatus = function (sortable, sorted, descending, disabled) {
    if (sorted) {
        if (descending) {
            return 'descending';
        }
        return 'ascending';
    }
    if (sortable && !disabled) {
        return 'sortable';
    }
    return undefined;
};
export var getSortingIconName = function (sortingState) { return stateToIcon[sortingState]; };
export var getAriaSort = function (sortingState) { return stateToAriaSort[sortingState]; };
export var isSorted = function (column, sortingColumn) {
    return column === sortingColumn ||
        (column.sortingField !== undefined && column.sortingField === sortingColumn.sortingField) ||
        (column.sortingComparator !== undefined && column.sortingComparator === sortingColumn.sortingComparator);
};
//# sourceMappingURL=utils.js.map